import api from 'api';
import storage from "@/cflow/storageService";

class UsuariosService {

    listar(dados, skipedLab, skipedDen) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/usuarios?skipedLab='+skipedLab+'&skipedDen='+skipedDen+'&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    opcoesFiltro() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/usuarios?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(tipo, id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/usuarios/' + tipo + '/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvar(tipo, id, flag, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/usuarios/' + tipo + '/' + id + '/' + flag + '?token='+user.token, form).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new UsuariosService();